<template>
  <div class="therapeutic">
    <div class="card">
      <div v-for="(item,index) in childData" :key="index">
        <div v-if="item.therapeuticType!='2'">
          <el-form-item label-width="400px" :label="item.operationName" :prop="'therapeuticIndexList.' + index + '.therapeuticIndex'" :rules="rules.therapeuticIndex">
            <div class="flexForm">
              <el-input oninput="value=value.replace(/[^0-9.]/g, '')" v-model="item.therapeuticIndex" @input="testSX" placeholder="请输入"></el-input>
              <div>{{item.therapeuticUnits}}</div>
            </div>
          </el-form-item>
          <el-form-item v-if="msg=='zswzk'" label-width="90px" label="项目金额" :prop="'therapeuticIndexList.' + index + '.operationAmt'" :rules="rules.operationAmt">
            <div class="flexForm">
              <el-input oninput="value=value.replace(/[^0-9.]/g, '')" v-model="item.operationAmt" @input="testSX" placeholder="请输入"></el-input>
            </div>
          </el-form-item>
          <div class="cardNum" v-if="item.detailsExplain!=null&&item.detailsExplain!=''"> 说明：{{item.detailsExplain}}</div>
        </div>
        <div v-if="item.therapeuticType=='2'">
          <el-form-item label-width="400px" :label="item.operationName">
            <div class="flexForm">
              <el-input disabled v-model="item.operationIndex" @input="testSX" placeholder="请输入"></el-input>
              <div>{{item.therapeuticUnits}}</div>
            </div>
          </el-form-item>
          <el-form-item v-if="msg=='zswzk'" label-width="90px" label="项目金额" :prop="'therapeuticIndexList.' + index + '.operationAmt'" :rules="rules.operationAmt">
            <div class="flexForm">
              <el-input oninput="value=value.replace(/[^0-9.]/g, '')" v-model="item.operationAmt" @input="testSX" placeholder="请输入"></el-input>
            </div>
          </el-form-item>
          <div class="cardNum" v-if="item.detailsExplain!=null&&item.detailsExplain!=''"> 说明：{{item.detailsExplain}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['childData', 'msg'],
  data() {
    return {
      rules: {
        therapeuticIndex: [
          { required: true, message: '请添加治疗指数', trigger: 'blur' },
        ],
        operationAmt: [
          { required: true, message: '请添加项目金额', trigger: 'blur' },
        ],
      }
    }
  },
  methods: {
    testSX() {
      this.$forceUpdate()
    },
  }
}
</script>
<style scoped>
.flexForm {
  display: flex;
  width: 200px;
  padding: 5px 0;
  box-sizing: border-box;
}
.flexForm >>> .el-input {
  width: 80px !important;
  margin-right: 10px;
}
.flexForm >>> .el-input__inner {
  width: 80px !important;
}
.cardNum {
  color: #f56c6c;
  font-size: 14px;
  /* width: 600px; */
  padding-left: 15px;
  box-sizing: border-box;
}
.card {
  background: #e0e6f0;
  border-radius: 10px;
  margin-bottom: 10px;
}
.therapeutic >>> .el-form-item__label {
  text-align: left !important;
  padding-left: 5px;
  box-sizing: border-box;
}
</style>